exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.btn-purple {\n  color: #ffffff;\n  background-color: #964ed8;\n}\n.btn.btn-purple:hover {\n  color: #ffffff;\n  background-color: #964EED;\n}\n", ""]);

// exports
